// @ts-nocheck
import React from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import useTracking from 'hooks/analytics';

import List from 'components/common/List';
import RectangleTile from 'components/common/tile/RectangleTile';

import { pageSelected } from 'actions/pageView';

import { getContentRowMetadata } from 'support/analytics/analyticsHelper';

import Ref from 'models/propTypes/ref';
import Row from 'models/propTypes/row';

const trackContentEvent = (
  trackEvent,
  { rowTitle, rowPos, rowCol, tag, pageType },
) => {
  const eventData = {
    ...getContentRowMetadata(rowTitle, rowPos, rowCol),
    moduleAction: 'click',
    clickText: `${pageType} carousel - ${tag}`,
  };
  trackEvent(`${pageType} carousel interactions`, eventData);
};

const RectangleRow = ({
  displayTitle,
  title,
  row,
  rowClassName,
  titleClassName,
  forwardedRef,
  rowPos,
  onEndOfNavigationOverride,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();

  const renderItem = (item, index, ref) => {
    // console.log("renderItem info:", item)
    const tag = item?.tag?.key;
    const pageType = item?.tag?.type.name;
    const onClick = () => {
      dispatch(pageSelected(tag, pageType));
      trackContentEvent(trackEvent, {
        rowTitle: title,
        rowPos,
        rowCol: index + 1,
        tag,
        pageType,
      });
      history.push({
        pathname: `/${pageType}/${tag}`,
      });
    };

    return (
      <RectangleTile
        logoSrc={item?.staticImageUrl}
        title={item?.displayAbbreviation || item?.abbreviation}
        focusId={`row-${row.slug}-item-${item?.id}`}
        item={item}
        row={row}
        ref={ref}
        key={item?.id}
        onClick={onClick}
      />
    );
  };

  return (
    <React.Fragment>
      {displayTitle && (
        <div className={classNames(titleClassName, 'font-weight-bold')}>
          {title}
        </div>
      )}
      <List
        focusId={row.slug}
        data={row.data}
        buffer={6}
        className={rowClassName}
        renderItem={renderItem}
        peekRatio={0}
        restorationId={`${row.slug}`}
        ref={forwardedRef}
        onEndOfNavigationOverride={onEndOfNavigationOverride}
      />
    </React.Fragment>
  );
};

RectangleRow.propTypes = {
  displayTitle: PropTypes.bool.isRequired,
  title: PropTypes.string,
  row: Row.isRequired,
  rowClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  forwardedRef: Ref,
  rowPos: PropTypes.number,
  onEndOfNavigationOverride: PropTypes.func,
};

RectangleRow.defaultProps = {
  title: null,
  rowClassName: null,
  titleClassName: null,
  forwardedRef: null,
  rowPos: null,
  onEndOfNavigationOverride: null,
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <RectangleRow {...props} forwardedRef={ref} />
  )),
);
